export namespace UserConstants {
  export enum AdditionalDocumentType {
    IDENTITY_CARD = "IDENTITY_CARD",
    DRIVER_LICENSE = "DRIVER_LICENSE",
  }

  export enum BiometryStatus {
    PENDING = "PENDING",
    CAPTURE = "CAPTURE",
    STORED_DOCUMENTS = "STORED_DOCUMENTS",
    SENT_DOCUMENTS = "SENT_DOCUMENTS",
    MEDIATION = "MEDIATION",
    APPROVED = "APPROVED",
    REFUSED = "REFUSED",
    ERROR = "ERROR",
  }

  export enum ContactProvider {
    EMAIL = "EMAIL",
    SMS = "SMS",
    WHATSAPP = "WHATSAPP",
  }

  export enum ContactTitle {
    EMAIL = "E-mail",
    PHONE = "Telefone",
  }

  export enum ContactType {
    EMAIL = "EMAIL",
    PHONE = "PHONE",
  }

  export enum DocumentType {
    CPF = "CPF",
  }

  export enum Type {
    SELLER = "SELLER",
    BUYER = "BUYER",
    COLLABORATOR = "COLLABORATOR",
    KIRVANO = "KIRVANO",
  }

  export enum VerificationStatus {
    PENDING_DATA = "PENDING_DATA",
    VERIFIED_DATA = "VERIFIED_DATA",
    BIOMETRY_PENDING = "BIOMETRY_PENDING",
    BIOMETRY_UNDER_ANALYSIS = "BIOMETRY_UNDER_ANALYSIS",
    BIOMETRY_REFUSED = "BIOMETRY_REFUSED",
    BIOMETRY_APPROVED = "BIOMETRY_APPROVED",
  }

  export type VerificationCountdownType = "EMAIL" | "PHONE" | "PASSWORD";

  export const defaultTimer = 59; //seconds
}
